var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logoImg)?_c('div',{staticClass:"logo customer_logo"},[_c('img',{key:_vm.logoImg,staticClass:"customer-logo",attrs:{"src":_vm.logoImg,"alt":"회사 로고","width":"140","height":"30.5"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }